import { Component, Input } from '@angular/core';
import { IROPS_STATUS } from '@app/enums/irops.enum';

@Component({
  selector: 'flight-status-alert-rebrand',
  templateUrl: './flight-status-alert-rebrand.component.html',
  styleUrls: ['./flight-status-alert-rebrand.component.scss'],
  standalone: false,
})
export class FlightStatusAlertRebrandComponent {
  @Input() typeAlert: IROPS_STATUS | 'closed' = IROPS_STATUS.DELAYED;
  @Input() timeDif: any;
  typeIrops = IROPS_STATUS;

  get alertClass(): Record<string, boolean> {
    return {
      'FlightStatusAlert-containerAlert--cancelled': this.typeAlert === this.typeIrops.CANCELLED,
      'FlightStatusAlert-containerAlert--afected': this.typeAlert === this.typeIrops.DELAYED,
      'FlightStatusAlert-containerAlert--early': this.typeAlert === this.typeIrops.EARLY,
      'FlightStatusAlert-containerAlert--onTime':
        this.typeAlert === this.typeIrops.SCHEDULED || this.typeAlert === this.typeIrops.ON_TIME,
    };
  }
}
